<template lang='pug'>
  div.billSheet
    img(style="height: 200px;  width: 200px;" :src="image")
</template>

<script>
  export default {
    props: {
      image: {
        type: String,
        default: '',
      },
    },
    data () {
      return {

      }
    },
    mounted () {
      const vm = this
      setTimeout(() => {
        window.print()
        vm.$emit('endPrint')
      }, 500)
    },
  }
</script>

<style scoped lang="scss">
  @media print {
    .billSheet {
        background-color: white;
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        margin: 0;
        padding: 15px;
        font-size: 14px;
        line-height: 18px;
    }
  }
</style>
